import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface LayersIconProps {
  color?: string;
  style?: React.CSSProperties;
  height?: string;
  width?: string;
}

export default function LayersIcon({
  color = RoutalPalette.secondary60,
  style = {},
  height = `25px`,
  width = `25px`,
}: LayersIconProps) {
  return (
    <SvgIcon viewBox="0 0 25 25" style={{ fill: `none`, height: height, width: width, ...style }}>
      <path
        d="M12.3662 2.27148L2.36621 7.27148L12.3662 12.2715L22.3662 7.27148L12.3662 2.27148Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.36621 17.2715L12.3662 22.2715L22.3662 17.2715"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.36621 12.2715L12.3662 17.2715L22.3662 12.2715"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
